import {
  FilterLegacy,
  SimpleEventFilterType,
  ActiveCohortBuilderItemLegacy,
} from '@verantos-dev/types-cohorts';

import { FILTER_KEYS, SIMPLE_EVENT_FILTER_MAPPING } from './filterTypes';

export const getActiveFilter = (
  simpleEvent: ActiveCohortBuilderItemLegacy
):
  | { filter: FilterLegacy; type: SimpleEventFilterType; inputId?: string }
  | { filter: null; type: null; inputId: null } => {
  for (const filterKey of FILTER_KEYS) {
    const filters = simpleEvent[filterKey] as FilterLegacy[];
    const filter = filters.find((f) => f.updated || f.inputFields.length === 0);
    if (filter) {
      const ret = { filter, type: SIMPLE_EVENT_FILTER_MAPPING[filterKey], inputId: filter.updated };
      delete filter.updated;
      return ret;
    }
  }
  return { filter: null, type: null, inputId: null };
};
